class HeroSlider {
  constructor(el) {
    if (!el) return

    this._bind();

    this.dom = {
      el: el,

      // images: el.querySelectorAll(".image-wrapper"),
      images: el.querySelectorAll(".image-container img"),
      masks: el.querySelectorAll(".mask"),

      textContainer: el.querySelectorAll(".text-container"),

      maskPath: el.querySelector("#mask-path"),
      leftTrigger: el.querySelector(".left-trigger"),
      rightTrigger: el.querySelector(".right-trigger"),

      dots: el.querySelectorAll(".dot"),
      moveDots: el.querySelector(".move-dot"),
    }

    this.data = {
      cur: 0,
      last: 0,
      z: 2,
      max: this.dom.images.length - 1,
      isTransitioning: false,
    }

    this.pos = {
      start: {
        x: null,
        y: null,
      },
      cur: {
        x: null,
        y: null,
      }
    }

    this.swipeThreshold = 15;

    this._addEvents();
    this._preloadNeighborsLater();
  }

  _hydrateImage(img) {
    if (!img) return;

    const srcset = img.getAttribute("data-srcset");
    const src = img.getAttribute("data-src");

    if (srcset) {
      img.setAttribute("srcset", srcset);
      img.removeAttribute("data-srcset");
    }
    if (src) {
      img.setAttribute("src", src);
      img.removeAttribute("data-src");
    }
  }

  _preloadNeighborsLater() {
    const preload = () => this._preloadNeighbors();
    if ("requestIdleCallback" in window) {
      requestIdleCallback(preload, { timeout: 2500 });
    } else {
      window.addEventListener("load", preload);
    }
  }

  _preloadNeighbors() {
    if (!this.dom.images.length) return;
    const nextIndex = this.data.cur >= this.data.max ? 0 : this.data.cur + 1;
    const prevIndex = this.data.cur <= 0 ? this.data.max : this.data.cur - 1;
    this._hydrateImage(this.dom.images[nextIndex]);
    if (prevIndex !== nextIndex) this._hydrateImage(this.dom.images[prevIndex]);
  }

  _bind() {
    ['next', 'prev', 'updateDots', 'touchstart', 'touchmove']
      .forEach(fn => this[fn] = this[fn].bind(this));
  }

  _addEvents() {
    if (this.dom.rightTrigger) this.dom.rightTrigger.addEventListener("click", this.next, false);
    if (this.dom.leftTrigger) this.dom.leftTrigger.addEventListener("click", this.prev, false);
    this.dom.dots.forEach((dot, i) => {
      dot.addEventListener("click", () => { this.clickDot(i) }, false);
    });

    this.dom.el.addEventListener("touchstart", this.touchstart)
    this.dom.el.addEventListener("touchmove", this.touchmove)
  }

  touchstart(e) {
    if (!e.touches) return

    this.pos.start.x = this.pos.cur.x = e.touches[0].pageX;
    this.pos.start.y = this.pos.cur.y = e.touches[0].pageY;
  }

  touchmove(e) {
    if (!e.touches) return

    this.pos.cur.x = e.touches[0].pageX;
    this.pos.cur.y = e.touches[0].pageY;

    let distX = this.pos.start.x - this.pos.cur.x;
    let distY = this.pos.start.y - this.pos.cur.y;

    if (Math.abs(distY) > 8) return

    if (distX > this.swipeThreshold) {
      this.next()

      this.pos.start.x = this.pos.cur.x;
      this.pos.start.y = this.pos.cur.y;
    } else if (distX < -this.swipeThreshold) {
      this.prev();

      this.pos.start.x = this.pos.cur.x;
      this.pos.start.y = this.pos.cur.y;
    }
  }

  next(index) {
    if (this.data.isTransitioning) return

    this.data.isTransitioning = true;

    this.data.z += 1;

    if (Number.isInteger(index)) {
      this.data.cur = index;
    } else {
      this.data.cur += 1;
      if (this.data.cur > this.data.max) this.data.cur = 0;
    }

    this._hydrateImage(this.dom.images[this.data.cur]);

    const tl = gsap.timeline({});

    tl.to(this.dom.textContainer[this.data.last], 0.5, { autoAlpha: 0, force3D: true, ease: "sine.Out" }, .1)
    tl.fromTo(this.dom.textContainer[this.data.cur], 0.5,
      { autoAlpha: 0 },
      { autoAlpha: 1, force3D: true, ease: "sine.Out" }, ">-.1")

    tl.fromTo(this.dom.images[this.data.cur], 1.2,
      { scale: 1.1, yPercent: -100, zIndex: this.data.z, opacity: 1 },
      { scale: 1, yPercent: 0, zIndex: this.data.z, transformOrigin: "50% 100%", ease: Expo.easeInOut }, 0)
    tl.to(this.dom.images[this.data.last], 1.2, { yPercent: 50, scale: 1.1, transformOrigin: "50% 0%", ease: Expo.easeInOut }, 0)

    tl.add(() => { this.data.isTransitioning = false }, "<.9");




    this.updateDots();

    this.data.last = this.data.cur;
    this._preloadNeighbors();
  }

  prev(index) {
    if (this.data.isTransitioning) return

    this.data.isTransitioning = true;

    this.data.z += 1;

    if (Number.isInteger(index)) {
      this.data.cur = index;
    } else {
      this.data.cur -= 1;
      if (this.data.cur < 0) this.data.cur = this.data.max;
    }

    this._hydrateImage(this.dom.images[this.data.cur]);

    let tl = new gsap.timeline();

    tl.to(this.dom.textContainer[this.data.last], 0.5, { autoAlpha: 0, force3D: true, ease: "sine.inOut" })
    tl.fromTo(this.dom.textContainer[this.data.cur], 0.5,
      { autoAlpha: 0 },
      { autoAlpha: 1, force3D: true, ease: "sine.inOut" }, ">-.1")

    tl.fromTo(this.dom.images[this.data.cur], 1.2,
      { scale: 1.2, yPercent: 100, zIndex: this.data.z, opacity: 1 },
      { scale: 1, yPercent: 0, zIndex: this.data.z, transformOrigin: "50% 0%", ease: Expo.easeInOut }, 0)
    tl.to(this.dom.images[this.data.last], 1.2, { yPercent: -50, scale: 1.1, transformOrigin: "50% 100%", ease: Expo.easeInOut }, 0)
    tl.add(() => { this.data.isTransitioning = false }, "<.9");

    this.updateDots();

    this.data.last = this.data.cur;
    this._preloadNeighbors();
  }

  updateDots() {
    // this.dom.dots.forEach(dot => {
    //    dot.classList.remove("is-selected")
    // })

    // this.dom.dots[this.data.cur].classList.add("is-selected")

    let newX = this.data.cur * 19;
    // let newX = this.data.cur * 30;
    gsap.to(this.dom.moveDots, 0.9, { x: newX, force3D: true, ease: Expo.easeInOut, delay: 0.4 })
  }

  clickDot(index) {
    if (index === this.data.cur) return

    if (index > this.data.cur) {
      this.next(index)
    } else {
      this.prev(index)
    }
  }
}

// customElements.define('hero-slider', HeroSlider);
